import { FC, SVGAttributes } from 'react'

export const VisaIcon: FC<SVGAttributes<HTMLOrSVGElement>> = (props) => {
  return (
    <svg width="67" height="42" viewBox="0 0 67 43" fill="none" {...props}>
      <g clipPath="url(#clip0_1125_1119)">
        <path
          d="M63.2188 0.539429H4.44538C2.50749 0.539429 0.936523 2.11827 0.936523 4.06588V38.5369C0.936523 40.4845 2.50749 42.0634 4.44538 42.0634H63.2188C65.1567 42.0634 66.7277 40.4845 66.7277 38.5369V4.06588C66.7277 2.11827 65.1567 0.539429 63.2188 0.539429Z"
          fill="#0E4595"
        />
        <path
          d="M25.3403 30.0054L28.2668 12.7467H32.9476L30.019 30.0054H25.3403ZM46.9296 13.119C46.0022 12.7694 44.5491 12.3942 42.7345 12.3942C38.1093 12.3942 34.8514 14.7348 34.8237 18.0896C34.7976 20.5696 37.1495 21.953 38.925 22.7786C40.747 23.6244 41.3594 24.1639 41.3508 24.9194C41.3392 26.0762 39.8958 26.6047 38.5505 26.6047C36.677 26.6047 35.6817 26.3432 34.1446 25.6987L33.5414 25.4245L32.8844 29.2881C33.9777 29.7698 35.9994 30.1871 38.0984 30.2087C43.0187 30.2087 46.2127 27.8948 46.2491 24.3123C46.2667 22.3492 45.0196 20.855 42.3192 19.6232C40.6832 18.8249 39.6812 18.2921 39.6918 17.4837C39.6918 16.7663 40.5398 15.9992 42.3723 15.9992C43.903 15.9754 45.0117 16.3108 45.8756 16.6604L46.295 16.8596L46.9296 13.1189M58.9743 12.7467H55.3575C54.2369 12.7467 53.3985 13.0541 52.9064 14.1779L45.9549 29.9944H50.8701C50.8701 29.9944 51.6737 27.8677 51.8555 27.4009C52.3927 27.4009 57.1674 27.4083 57.8501 27.4083C57.9901 28.0125 58.4195 29.9944 58.4195 29.9944H62.7629L58.9743 12.7467ZM53.2358 23.8909C53.6229 22.8965 55.1007 19.0665 55.1007 19.0665C55.073 19.1125 55.485 18.0672 55.7214 17.4193L56.0377 18.9073C56.0377 18.9073 56.9339 23.0269 57.1212 23.8909H53.2358Z"
          fill="white"
        />
        <path
          d="M4.96119 12.7467L4.90137 13.1059C6.7515 13.556 8.40409 14.2074 9.85079 15.0177L14.0041 29.9779L18.9564 29.9721L26.3253 12.7467H21.3671L16.7846 24.5159L16.2963 22.1241C16.2733 22.0506 16.2493 21.9774 16.2241 21.9046L14.6306 14.2037C14.3472 13.1109 13.5254 12.7848 12.5088 12.7467H4.96119Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1125_1119">
          <rect
            width="65.7912"
            height="41.5239"
            fill="white"
            transform="translate(0.936523 0.539429)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
